import React from "react";

function TruckXxl() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="96.65"
      height="30.554"
      viewBox="0 0 96.65 30.554"
    >
      <g transform="translate(.325 .325)">
        <path
          d="M1101.458 54.895a4.673 4.673 0 01-7.906-2.3"
          className="cls-1"
          transform="translate(-1039.545 -26.39)"
        ></path>
        <path
          d="M1095.335 56.271a4.677 4.677 0 01-5.492-3.537"
          className="cls-1"
          transform="translate(-1037.69 -26.461)"
        ></path>
        <path
          d="M1111.827 56.326a4.677 4.677 0 01-5.153-3.594"
          className="cls-1"
          transform="translate(-1046.11 -26.46)"
        ></path>
        <path
          d="M1117.191 56.364h-2.222a4.674 4.674 0 01-4.556-3.632"
          className="cls-1"
          transform="translate(-1047.981 -26.46)"
        ></path>
        <g transform="translate(7.634 26.229)">
          <path
            d="M1010.958 55.946a4.677 4.677 0 01-6.469-3.237"
            className="cls-1"
            transform="translate(-1002.621 -52.677)"
          ></path>
          <path
            d="M1020.918 56.317h-.165a4.674 4.674 0 01-4.566-3.675"
            className="cls-1"
            transform="translate(-1008.473 -52.645)"
          ></path>
          <path
            d="M1006.074 56.291a4.678 4.678 0 01-5.324-3.58"
            className="cls-1"
            transform="translate(-1000.75 -52.678)"
          ></path>
          <path
            d="M1017.868 56.323a4.679 4.679 0 01-5.387-3.523"
            className="cls-1"
            transform="translate(-1006.619 -52.723)"
          ></path>
        </g>
        <path
          d="M1047.626 57.737a4.683 4.683 0 01-4.841-2.091"
          className="cls-1"
          transform="translate(-1014.146 -27.917)"
        ></path>
        <path
          d="M1045.311 52.725a4.674 4.674 0 004.557 3.635c.806 0 1.4-.01 2.227-.01"
          className="cls-1"
          transform="translate(-1015.41 -26.456)"
        ></path>
        <path
          d="M1140.274 54.727a4.674 4.674 0 01-8.235.328"
          className="cls-1"
          transform="translate(-1058.8 -27.458)"
        ></path>
        <path
          d="M1154.589 56.339h-2.222a4.674 4.674 0 01-4.562-3.656"
          className="cls-1"
          transform="translate(-1066.689 -26.435)"
        ></path>
        <path
          d="M1164.793 24.3v-8.286a.569.569 0 00-.166-.4l-1.254-1.254-1.3-10.366a1.136 1.136 0 00-1.127-1h-8.938"
          className="cls-1"
          transform="translate(-1068.793 -1.577)"
        ></path>
        <path
          d="M1146.328 24.3V3h2.84v20.45"
          className="cls-1"
          transform="translate(-1065.949 -1.577)"
        ></path>
        <path
          d="M1069.215 45.627h22.464"
          className="cls-1"
          transform="translate(-1027.369 -22.905)"
        ></path>
        <path
          d="M1134.486 45.627h8.474"
          className="cls-1"
          transform="translate(-1060.025 -22.905)"
        ></path>
        <path
          d="M1171.065 45.627h2.97v2.982a.568.568 0 01-.568.568h-2.982"
          className="cls-1"
          transform="translate(-1078.035 -22.905)"
        ></path>
        <path
          d="M1016.734 22.877V.155h63.622a1.136 1.136 0 011.136 1.136"
          className="cls-1"
          transform="translate(-1001.113 -.155)"
        ></path>
        <path
          d="M988.315 22.877V1.575a1.42 1.42 0 011.42-1.42h12.781"
          className="cls-1"
          transform="translate(-986.895 -.155)"
        ></path>
        <path
          d="M1152.946 45.972a5.607 5.607 0 10-11.056 0l.021.106h-8.667"
          className="cls-1"
          transform="translate(-1059.403 -19.804)"
        ></path>
        <circle
          cx="4.672"
          cy="4.672"
          r="4.672"
          className="cls-1"
          transform="translate(83.228 20.559)"
        ></circle>
        <circle
          cx="2.804"
          cy="2.804"
          r="2.804"
          className="cls-2"
          transform="translate(85.097 22.429)"
        ></circle>
        <path
          d="M1031.776 45.972a5.607 5.607 0 10-11.135-.936 5.679 5.679 0 00.079.934l.017.106h-3.35"
          className="cls-1"
          transform="translate(-1001.44 -19.804)"
        ></path>
        <path
          d="M1016.975 45.627h3.856"
          className="cls-1"
          transform="translate(-1001.233 -22.905)"
        ></path>
        <path
          d="M1057.013 45.972a5.674 5.674 0 00.079-.934 5.607 5.607 0 10-11.135.933l.016.106h-2.1"
          className="cls-1"
          transform="translate(-1014.692 -19.804)"
        ></path>
        <path
          d="M1023.066 56.156a4.677 4.677 0 01-5.528-3.646"
          className="cls-1"
          transform="translate(-1001.515 -26.348)"
        ></path>
        <path
          d="M1028.118 56.4h-2.227a4.675 4.675 0 01-4.547-3.592"
          className="cls-1"
          transform="translate(-1003.419 -26.499)"
        ></path>
        <circle
          cx="4.672"
          cy="4.672"
          r="4.672"
          className="cls-1"
          transform="translate(20.021 20.559)"
        ></circle>
        <circle
          cx="4.672"
          cy="4.672"
          r="4.672"
          className="cls-1"
          transform="translate(32.007 20.559)"
        ></circle>
        <circle
          cx="2.804"
          cy="2.804"
          r="2.804"
          className="cls-2"
          transform="translate(21.89 22.429)"
        ></circle>
        <circle
          cx="2.804"
          cy="2.804"
          r="2.804"
          className="cls-2"
          transform="translate(33.876 22.429)"
        ></circle>
        <path
          d="M1101.7 45.972a5.674 5.674 0 00.079-.934 5.607 5.607 0 10-11.135.933l.039.106h-22.511"
          className="cls-1"
          transform="translate(-1026.849 -19.804)"
        ></path>
        <circle
          cx="4.672"
          cy="4.672"
          r="4.672"
          className="cls-1"
          transform="translate(64.537 20.559)"
        ></circle>
        <circle
          cx="2.804"
          cy="2.804"
          r="2.804"
          className="cls-2"
          transform="translate(66.407 22.429)"
        ></circle>
        <path
          fill="none"
          stroke="#2a2e43"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="0.284"
          d="M6.541 16.821h3.738a.935.935 0 01.935.934.935.935 0 01-.935.934H6.541a.934.934 0 01-.934-.934.934.934 0 01.934-.934z"
          style={{ isolation: "isolate" }}
          opacity="0.2"
        ></path>
        <path
          d="M1163.375 15.78h-8.521V5.839h6.868a.426.426 0 01.423.372z"
          className="cls-1"
          transform="translate(-1070.215 -2.999)"
        ></path>
        <path
          fill="none"
          stroke="#2a2e43"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="0.284"
          d="M84.639 14.201h2.13a.71.71 0 01-.71.71h-.71a.71.71 0 01-.71-.71z"
          opacity="0.2"
        ></path>
        <path
          fill="none"
          stroke="#2a2e43"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="0.284"
          d="M84.639 14.201h2.13a.426.426 0 01-.43.426h-1.274a.426.426 0 01-.426-.426z"
        ></path>
        <rect
          width="16.331"
          height="3.55"
          className="cls-1"
          rx="1.137"
          transform="translate(0 22.722)"
        ></rect>
        <rect
          width="3.037"
          height="2.804"
          className="cls-1"
          rx="1.402"
          transform="translate(.568 23.095)"
        ></rect>
        <rect
          width="3.037"
          height="2.804"
          className="cls-1"
          rx="1.402"
          transform="translate(12.726 23.095)"
        ></rect>
      </g>
    </svg>
  );
}

export default TruckXxl;
